module.exports = __webpack_public_path__ + "static/img/ic_word.bbb8a27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/documentPic/ic_word.png
// module id = 1022
// module chunks = 1